export const WEB_APP_VERSION = __WEB_APP_VERSION__;
